import { Trans, useLingui } from '@lingui/react/macro';

import { RadioItemYesNo } from '@/design_system/Radio/RadioItem/RadioItem';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { Brand, useUpdateBrand } from '@/models/brand';

export const ContractualObligationToHandle = ({ brand }: { brand: Brand }) => {
  const { t } = useLingui();
  const { mutateAsync: updateBrand, isPending: isUpdateBrandPending } = useUpdateBrand(brand.id);

  return (
    <Stack gap="0.5em">
      <Title as="h2" size="400" weight="medium">
        <Trans id="settings.organization.data-catalogs.brands.tab.overview.contractual-obligation">
          Contractual obligation to handle
        </Trans>
      </Title>

      <RadioItemYesNo
        name="contractual-obligation-to-handle"
        ariaLabel={t({
          id: 'settings.organization.data-catalogs.brands.tab.overview.contractual-obligation',
          message: 'Contractual obligation to handle',
        })}
        value={brand.contractualObligationToHandle ? 'yes' : 'no'}
        onChange={(newValue) => {
          const newValueBoolean = newValue === 'yes' ? true : false;

          if (newValueBoolean !== brand.contractualObligationToHandle) {
            updateBrand({ contractualObligationToHandle: newValueBoolean });
          }
        }}
        disabled={isUpdateBrandPending}
      />
    </Stack>
  );
};
